<template>
    <div name="hospital" class="wrapper">
        <div class="page" v-if="isView">
            <banner 
                v-if="hospital"
                :images="hospital.promotion_data.profile.images"
            />
            <info
                v-if="hospital"
                :promotion_data="hospital.promotion_data"
                :schedules="hospital.promotion_data.schedule"
                @call="tel(hospital.promotion_data.profile.representative_number)"
                :hasContact="hasContact"
                :hasContactless="hasContactless"
            />
            <map-view 
                v-if="hospital"
                :address="hospital.promotion_data.profile.address"
            />
            <schedule
                v-if="hospital"
                :schedules="hospital.promotion_data.schedule"
                @service-types="onServiceTypes"
            />
            <operating-hours 
                :text="hospital.promotion_data.custom_schedule_description"
            />
            <medicals 
                v-if="hospital"
                :departments="hospital.promotion_data.departments"
                :subjects="hospital.promotion_data.additional_department_description"
                :fixSubject="hospital.promotion_data.subject[0]"
            />
            <doctors 
                v-if="hospital"
                :doctor_list="hospital.doctor_list"
            />
            <div class="bottom-button" v-if="hospital">
                <template v-if="!hasContact">
                    <div class="call-button" @click="(hospital.additional_link === '' || hospital.additional_link === null) ? tel(hospital.promotion_data.profile.representative_number) : openUlr(hospital.additional_link)">
                        <img style="width: 24px;" src="../../assets/call_icn.png" />
                        <span style="margin-left: 10px;">{{(hospital.additional_link === '' || hospital.additional_link === null) ? '병원으로 연락하기' : '대면진료 예약하기'}}</span>
                    </div>
                    <div class="kakao-button" @click="login('CONTACTLESS')">
                        <img style="width: 24px;" src="../../assets/kakao.png" />
                        <span style="margin-left: 10px;">비대면진료 예약하기</span>
                    </div>
                </template>
                <template v-else>
                    <div class="button-row">
                        <div class="booking-button contact" @click="login('CONTACT')">
                            <span>대면진료 예약하기</span>
                        </div>
                        <div class="booking-button contactless" @click="login('CONTACTLESS')">
                            <span>비대면진료 예약하기</span>
                        </div>
                    </div>
                    <span class="login-notice">카카오톡으로 로그인됩니다</span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import axios from 'axios';
import Banner from '@/components/hospital/Banner';
import Info from '@/components/hospital/Info';
import Medicals from '@/components/hospital/Medicals';
import Doctors from '@/components/hospital/Doctors';
import Schedule from '@/components/hospital/Schedule';
import MapView from '@/components/hospital/Map';
import OperatingHours from '@/components/hospital/OperatingHours'

export default {
    components: { 
        Banner,
        Info,
        Medicals,
        Doctors,
        Schedule,
        MapView,
        OperatingHours
    },
    name: 'hospital',
    data: function()
    {
        return {
            uuid: null,
            isView: false,
            data: [
                {uuid: "1607405803", name: '도브의원', banner: 'https://d1xox7kqzxfqzz.cloudfront.net/admin/promotion/1607405803/기광고확정안.jpg'},
                {uuid: "2439198062", name: '고양신세계안과의원', banner: 'https://d1xox7kqzxfqzz.cloudfront.net/admin/promotion/16825588576/고양신세계안과의원_1.png'},
                {uuid: "1678194785", name: '신세계 이비인후과', banner: 'https://d1xox7kqzxfqzz.cloudfront.net/admin/promotion/16825588576/신세계이비인후과_1.jpg'},
            ],
            selected: null,
            hospital: null,
            hasContact: false,
            hasContactless: false
        }
    },
    mounted: async function()
    {
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        this.uuid = this.$route.params.uuid;

        if(this.uuid === null || this.uuid === undefined || this.uuid === '' || this.uuid === '0')
        {
            
        }
        if(this.$route.query.kakao)
        { 
            this.isView = false;
            this.afterLogin(this.$route.query.kakao, this.$route.query.serviceType);
        }
        else
        {
            // this.selected = this.data.find(item => item.uuid === this.uuid)
            this.isView = true;

            // AdBrix: 진입 이벤트
            this.sendEvent('is_quick_landing_view');

            // fetch data 
            const url = `${process.env.ADMIN_API_ROOT}/v1/hospital/${this.uuid}/promotion`;                
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `${process.env.ADMIN_API_KEY}` //GihCEC8mQTUaT_8vbNc3-kEkQCEskV .KK9vp3Kaa7pHU8Vvjx7BQg3xsVcU_
                }
            });

            this.hospital = response.data.data;
            // alert(JSON.stringify(this.hospital.promotion_data.profile.address))
            
        }
    },
    methods: {
        sendEvent: function(eventName, properties)
        {
            console.log('[AdBrix]', eventName, properties || {});
            try {
                if (window.adbrix && window.adbrix.event && typeof window.adbrix.event.send === 'function') {
                    window.adbrix.event.send(eventName, properties || {});
                }
            } catch (e) {
                // AdBrix 미로드 등 예외는 무시
            }
        },
        login: function(serviceType)
        {
            // AdBrix: 로그인 버튼 클릭 이벤트
            this.sendEvent('is_landing_login_click');

            const REST_API_KEY = process.env.KAKAO_REST_API_KEY;
            const REDIRECT_URI = process.env.KAKAO_REDIRECT_URI;
            // 카카오 로그인 후 돌아왔을 때 선택한 serviceType 을 알 수 있도록 state 에 포함
            let STATE = encodeURIComponent(`${process.env.LOGIN_URI}/hospital/${this.uuid}?serviceType=${serviceType}`);
            window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code&prompt=login&state=${STATE}`;
        },
        afterLogin: function(kakaoId, serviceType)
        {
            // alert(kakaoId)
            this.$store.dispatch(Constant.AUTH_INAPP, {type: this.uuid, id: kakaoId, ref: null})
                .then((response) => {
                    // console.log(JSON.stringify(response))
                    window.location.href = this.appendServiceType(response, serviceType || 'CONTACTLESS');
                })
                .catch((err) => {

                })
        },
        appendServiceType: function(redirectUrl, serviceType)
        {
            // redirect_template.params 에 serviceType 추가 (나머지 쿼리는 원본 인코딩 그대로 유지)
            try {
                return redirectUrl.replace(/([?&]redirect_template=)([^&#]*)/, (match, prefix, value) => {
                    const template = JSON.parse(decodeURIComponent(value.replace(/\+/g, ' ')));
                    template.params = Object.assign({}, template.params, { serviceType: serviceType });
                    return prefix + encodeURIComponent(JSON.stringify(template));
                });
            } catch (e) {
                return redirectUrl;
            }
        },
        openUlr: function(url)
        {
             window.location.href = url;
        },
        tel: function(phone)
        {
            window.location.href = `tel:${phone}`;
        },
        onServiceTypes: function({ hasContact, hasContactless })
        {
            this.hasContact = hasContact;
            this.hasContactless = hasContactless;
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        height: 100dvh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .page {
        width: 100%;
        height: 100dvh;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 0 16px 200px 16px;
        overflow-y: auto;
    
    }
    .row {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
    }

    .title {
        color: #1A1B1E;
        font-family: Pretendard;
        font-size: 5vh;
        font-style: normal;
        font-weight: 700;
    }
    .kakao-button {
        width: 100%;
        display: flex;
        height: 55px;
        border-radius: 6px;
        background: #FFE601;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        position: relative;
        cursor: pointer;
    }
    .kakao-button-icon {
        margin-right: 8px;
        width: 24px;
    }
   
    .line {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .description {
            color: #6E717D;
            font-family: Pretendard;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            margin-top: 16px;
            line-height: 23px;
            text-align: center;
    }
    .small {
        color: #6E717D;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        margin-top: 20px;
        opacity: 0.8;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
            height: 100dvh;
        }
    }
    @media (min-height: 580px) {
       .title {
            color: #1A1B1E;
            font-family: Pretendard;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
        }

    }
    .responsive-img {
        width: 100%;
    }
    .bottom-button {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        max-width: 600px;
        width: 100%;
        position: fixed;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 0;
        padding: 16px;
        box-sizing: border-box;
        /* background: linear-gradient(0deg, #F3F5F8 0%, rgba(255, 255, 255, 0.00) 255.33%); */
        background: #FFF;
    }
    .kakao-button {
        display: flex;
        width: 100%;
        height: 54px;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: #FBE44D;
        color: rgba(0, 0, 0, 0.85);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
    .button-row {
        display: flex;
        width: 100%;
    }
    .booking-button {
        flex: 1;
        min-width: 0;
        display: flex;
        height: 54px;
        justify-content: center;
        align-items: center;
        padding: 0 8px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: center;
        font-family: Pretendard;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: -0.3px;
        white-space: nowrap;
        cursor: pointer;
        color: #FFF;
    }
    .booking-button.contact {
        background: #0096FF;
    }
    .booking-button.contactless {
        background: #0C3E90;
    }
    .booking-button + .booking-button {
        margin-left: 8px;
    }
    .login-notice {
        margin-top: 10px;
        color: #8A8D96;
        font-family: Pretendard;
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        text-align: center;
    }
    @media (max-width: 359px) {
        .booking-button {
            font-size: 14px;
        }
    }
    .call-button {
        display: flex;
        width: 100%;
        height: 54px;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        color: rgba(0, 0, 0, 0.85);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
</style>


// WEBPACK FOOTER //
// src/page/hospital/index.vue